import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mui-number-badge',
  templateUrl: './mui-number-badge.component.html',
  styleUrls: ['./mui-number-badge.component.scss']
})
export class MuiNumberBadgeComponent {
  @Input()
  disableDelay = false;

  @Input()
  @HostBinding('aria-label')
  label: string | null = null;

  protected _count = 0;

  @Input()
  set count(value: number) {
    if (this.isAnimating() && this._count !== value && !this.disableDelay) {
      this._count = 0;
      setTimeout(() => {
        this._count = value;
      }, 100);
    } else {
      this._count = value;
    }
  }

  isAnimating(): boolean {
    return this._count > 0;
  }
}
